import { Divider } from "primereact/divider"
import { Button } from "primereact/button"
import confirmation from "../../../function/confirmation"
import api from "../../../api"
import commonStyles from "../../common.module.css"

export default function TaskNotifications({ notifications = [], refresh }) {
  // const { user: userDetail } = useContext(userContext)

  // const myNotifications = useMemo(() =>
  //   notifications.filter((notification) =>
  //     notification.users.some((user) => user.uuid === userDetail.uuid
  //     )
  //   ), [notifications, userDetail.uuid])

  // if (myNotifications.length === 0) {
  //   return <></>
  // }

  const onDelete = async (uuid) => {
    await api.delete(`/task-notification/${uuid}`)
    refresh()
  }

  return (
    <>
      <Divider className={"mt-6"}>Notifikace</Divider>
      {notifications.length === 0 ? (
        <div className={`${commonStyles.emptyMessage} font-italic mb-3`}>Žádná nofitikace...</div>
      ) : (
        <ul>
          {notifications.map((notification) => (
            <li key={notification.uuid}>
              <div className="flex align-items-center">
                <div>
                  {notification.days} dní předem <small>(<i>{notification.users
                    .map((user) => user.name)
                    .join(", ")}</i>)</small>
                </div>

                <Button
                  icon="pi pi-times"
                  className="p-button-sm p-button-text p-button-danger ml-auto"
                  onClick={(e) => {
                    confirmation(e.currentTarget, "Opravdu smazat?", () => onDelete(notification.uuid))
                  }}
                />
              </div>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}
